import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import VolunteersHighlightForm, {
	applyLocalizableChanges,
	VolunteersHighlightGeneralValues,
	VolunteersHighlightLocalizableChanges,
} from "../../components/VolunteersHighlightForm";
import {
	useVolunteersHighlightContext,
	VOLUNTEERS_HIGHLIGHT_LIST_PATH,
} from "../../context/VolunteersHighlightContext/VolunteersHighlightContext";
import { Culture } from "../../context/VolunteersHighlightContext/constants";

const EditVolunteersHighlight = () => {
	const { id } = useParams<{ id: string }>();
	const {
		updateVolunteersHighlight,
		getVolunteersHighlightDetails,
		clearVolunteersHighlightFormData,
		volunteersHighlightEditForm,
		setVolunteersHighlightEditForm,
		operationStatus,
	} = useVolunteersHighlightContext();

	const isFetching = operationStatus.type === "loading" && operationStatus.operation === "fetch";

	useEffect(() => {
		if (id) {
			getVolunteersHighlightDetails(id);
		}

		return () => {
			clearVolunteersHighlightFormData();
		};
	}, [id, getVolunteersHighlightDetails, clearVolunteersHighlightFormData]);

	const handleGeneralChange = useCallback((changes: Partial<VolunteersHighlightGeneralValues>) => {
		setVolunteersHighlightEditForm(prev => (prev ? { ...prev, ...changes } : null));
	}, [setVolunteersHighlightEditForm]);

	const handleLocalizableChange = useCallback((culture: Culture, changes: VolunteersHighlightLocalizableChanges) => {
		setVolunteersHighlightEditForm(prev => (prev ? {
			...prev,
			volunteersHighlightLocalizable: applyLocalizableChanges(prev.volunteersHighlightLocalizable, culture, changes),
		} : null));
	}, [setVolunteersHighlightEditForm]);

	return (
		<>
			<BackComponent text="Öne Çıkanlar Listesine Dön" to={VOLUNTEERS_HIGHLIGHT_LIST_PATH} />
			<ActionContainer>
				<Spin spinning={isFetching}>
					<ActionItemsContainer>
						<FormHeaderComponent>Öne Çıkan Güncelleme</FormHeaderComponent>
						{volunteersHighlightEditForm && (
							<VolunteersHighlightForm
								key={volunteersHighlightEditForm.highlightId}
								general={volunteersHighlightEditForm}
								localizables={volunteersHighlightEditForm.volunteersHighlightLocalizable}
								isRequired={false}
								onGeneralChange={handleGeneralChange}
								onLocalizableChange={handleLocalizableChange}
							/>
						)}
						<SubmitButtonOverlay>
							<MainButtonComponent
								onClick={updateVolunteersHighlight}
								type="default"
								disabled={!volunteersHighlightEditForm}
								loading={operationStatus.type === "loading" && operationStatus.operation === "update"}
							>
								Güncelle
							</MainButtonComponent>
						</SubmitButtonOverlay>
					</ActionItemsContainer>
				</Spin>
			</ActionContainer>
		</>
	);
};

export default EditVolunteersHighlight;
